import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ProfileCreate from './Set/ProfileCreate';
import Head from '../components/Header';

function Setting() {
  const [tabValue, setTabValue] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [userType, setUserType] = useState(null);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem('activeSettingTab', newValue);
  };

  const handleDropdownChange = (event) => {
    setTabValue(event.target.value);
    localStorage.setItem('activeSettingTab', event.target.value);
  };

  const handleResize = () => {
    if (window.innerWidth <= 600) {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const storedTab = localStorage.getItem('activeSettingTab');
    if (storedTab !== null) {
      setTabValue(parseInt(storedTab));
    }

    const storedUserType = localStorage.getItem('usertype');
    if (storedUserType !== null) {
      setUserType(parseInt(storedUserType));
    }
  }, []);

  return (
    <div>
      <div>
        <Head />
        <br />
        <br />
      </div>

      {isMobileView ? (
        <div>
          <div style={{ margin: '1% 5%' }}>
            {/* <Select value={tabValue} onChange={handleDropdownChange} displayEmpty>
              <MenuItem value="" disabled>
                Select an option
              </MenuItem>
              {userType === 4 && <MenuItem value={0}>Profile Create</MenuItem>}
            </Select> */}
            <div style={{ margin: '1%', marginBottom: '4%' }}>
              {tabValue === 0 && userType === 4 && <ProfileCreate />}
            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* <div style={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="settings-tabs"
              variant="fullWidth"
              sx={{
                "& button": {
                  borderRadius: 10,
                  color: "#555",
                  margin: '20px',
                  fontSize: '14px',
                  minWidth: '150px', // Set a minimum width
                  width: '1200px', // Adjust width as needed
                  maxWidth: '700px',
                },
                "& button:hover": {
                  backgroundColor: "#eee",
                },
                "& button:active": {
                  backgroundColor: "#ddd",
                },
                "& button.Mui-selected": {
                  backgroundColor: "#007bff",
                  color: "#fff",
                },
                "& .MuiTabs-indicator": {
                  display: 'none',
                },
              }}
            >
              {userType === 4 && <Tab label="Profile Create" />}
            </Tabs>
          </div> */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '1%',
            marginBottom: '4%',
          }}>
            {tabValue === 0 && userType === 4 && <ProfileCreate />}
          </div>
        </div>
      )}
    </div>
  );
}

export default Setting;
